import { CartLineItem, Drawer, cartLineItemChangeQuantityEvent, cartLineItemName, cartLineItemRemoveEvent, cartLineItemTagName, productFormAddedItemsEvent, productFormName, } from '@/components/ui';
import { cart } from '@/lib/cart';
import { Section, defineSection } from '@decify/cell-shopify/client';
import './cart-drawer.scss';
export const cartDrawerName = 'CartDrawer';
export const cartDrawerTagName = 'cell-section-cart-drawer';
export const cartDrawerUpdateEvent = 'update';
class CartDrawer extends Section {
    domParser;
    constructor() {
        super(cartDrawerName);
        this.validateProps(['sectionId']);
        this.domParser = new DOMParser();
        this.handleAddItems = this.handleAddItems.bind(this);
        this.handleItemChangeQuantity = this.handleItemChangeQuantity.bind(this);
        this.handleItemRemove = this.handleItemRemove.bind(this);
        this.render = this.render.bind(this);
    }
    componentDidMount() {
        globalThis.subscribe(`${productFormName}.${productFormAddedItemsEvent}`, this.handleAddItems);
        this.subscribe(`${cartLineItemName}.${cartLineItemChangeQuantityEvent}`, this.handleItemChangeQuantity);
        this.subscribe(`${cartLineItemName}.${cartLineItemRemoveEvent}`, this.handleItemRemove);
    }
    // TODO: Fix this type error.
    // @ts-ignore
    handleAddItems(data) {
        const html = data.sections[this.props.sectionId];
        if (!html) {
            throw new Error('HTML not found');
        }
        this.render(this.domParser.parseFromString(html, 'text/html'));
        this.drawerElement.open();
    }
    async handleItemChangeQuantity(data) {
        const cartChangeItemResponse = await cart.changeItem({
            id: data.key,
            quantity: data.quantity,
        });
        if (!cartChangeItemResponse.success) {
            const updatedCartLineItemElement = this.querySelector(`${cartLineItemTagName}[data-key="${data.key}"]`);
            if (!updatedCartLineItemElement || !(updatedCartLineItemElement instanceof CartLineItem)) {
                throw new Error('Updated cart line item not found');
            }
            updatedCartLineItemElement.resetQuantity();
            updatedCartLineItemElement.showError(cartChangeItemResponse.error);
            updatedCartLineItemElement.setLoading(false);
            return;
        }
        // TODO: Fix this type error.
        // @ts-ignore
        const html = cartChangeItemResponse.data.sections[this.props.sectionId];
        if (!html) {
            throw new Error('HTML not found');
        }
        this.render(this.domParser.parseFromString(html, 'text/html'));
        this.publish(cartDrawerUpdateEvent, {
            // TODO: Fix this type error.
            // @ts-ignore
            sections: cartChangeItemResponse.data.sections,
        });
    }
    async handleItemRemove(data) {
        const cartRemoveItemResponse = await cart.removeItem(data.key);
        if (!cartRemoveItemResponse.success) {
            // TODO: Handle error.
            return;
        }
        // TODO: Fix this type error.
        // @ts-ignore
        const html = cartRemoveItemResponse.data.sections[this.props.sectionId];
        if (!html) {
            throw new Error('HTML not found');
        }
        this.render(this.domParser.parseFromString(html, 'text/html'));
        this.publish(cartDrawerUpdateEvent, {
            // TODO: Fix this type error.
            // @ts-ignore
            sections: cartRemoveItemResponse.data.sections,
        });
    }
    render(doc) {
        this.querySelectorAll('[cell-update]').forEach((element) => {
            const newElement = doc.querySelector(`[cell-update="${element.getAttribute('cell-update')}"]`);
            if (newElement) {
                element.replaceWith(newElement);
            }
        });
    }
    onSectionSelect() {
        this.drawerElement.open();
    }
    onSectionDeselect() {
        this.drawerElement.close();
    }
    get drawerElement() {
        const drawerElement = this.querySelector('cell-component-drawer');
        if (!drawerElement) {
            throw new Error('Drawer element not found');
        }
        // TODO: This currently throws an error on rerender because the cart-drawer mounts before the drawer.
        if (!(drawerElement instanceof Drawer)) {
            throw new Error('Drawer element is not an instance of Drawer');
        }
        return drawerElement;
    }
}
defineSection(cartDrawerTagName, CartDrawer);
